/**
 * Merge `list` under `templateFork` and `editor` under `templateFork.editor`
 * in each locale. Describes the rejected-revision lifecycle for forks.
 */
export const templateForkRejectionCopy = {
  en: {
    list: {
      draftsHeading: 'Unfinished forks',
      draftsDescription: 'Drafts you can continue editing. Nothing here is published yet.',
      draftsEmpty: 'No unfinished forks.',
      tabTemplates: 'Templates',
      rejectedHeading: 'Rejected revisions',
      rejectedDescription:
        'These forks were rejected in review. They are kept for history and are not waiting for review. Edit and save one to start a new revision.',
      rejectedBadge: 'Rejected',
      rejectedOn: 'Revision {{revision}} rejected {{date}}',
      rejectedReason: 'Reason: {{reason}}',
      startNewRevision: 'Start new revision',
    },
    editor: {
      rejectedBannerTitle: 'This revision was rejected',
      rejectedBannerBody:
        'Revision {{revision}} was rejected {{date}}, so it cannot be approved or published and review actions are turned off. Change the source and choose Save draft to create revision {{next}}, which returns to pending review. The rejection stays in the history.',
      rejectedBannerReason: 'Reviewer’s reason: {{reason}}',
      rejectedActionsNote: 'Review actions return after you save a new revision.',
      warningsNonBlocking: 'Warnings do not block approval or publishing.',
      errorsBlocking: 'These errors must be fixed before the revision can be approved.',
      previewNotesTitle: 'Preview notes',
      previewNotesNonBlocking: 'These come from the preview only and do not block publishing.',
    },
  },
  fa: {
    list: {
      draftsHeading: 'فورک‌های نیمه‌تمام',
      draftsDescription:
        'پیش‌نویس‌هایی که می‌توانید ویرایش را ادامه دهید. هنوز چیزی منتشر نشده است.',
      draftsEmpty: 'فورک نیمه‌تمامی وجود ندارد.',
      tabTemplates: 'قالب‌ها',
      rejectedHeading: 'بازبینی‌های ردشده',
      rejectedDescription:
        'این فورک‌ها در بررسی رد شده‌اند. برای سابقه نگه داشته می‌شوند و منتظر بررسی نیستند. برای شروع بازبینی جدید، یکی را ویرایش و ذخیره کنید.',
      rejectedBadge: 'ردشده',
      rejectedOn: 'بازبینی {{revision}} در {{date}} رد شد',
      rejectedReason: 'دلیل: {{reason}}',
      startNewRevision: 'شروع بازبینی جدید',
    },
    editor: {
      rejectedBannerTitle: 'این بازبینی رد شده است',
      rejectedBannerBody:
        'بازبینی {{revision}} در {{date}} رد شد؛ بنابراین نمی‌توان آن را تأیید یا منتشر کرد و اقدام‌های بررسی غیرفعال است. منبع را تغییر دهید و «ذخیره پیش‌نویس» را بزنید تا بازبینی {{next}} ساخته شود و دوباره در انتظار بررسی قرار گیرد. سابقهٔ رد باقی می‌ماند.',
      rejectedBannerReason: 'دلیل بازبین: {{reason}}',
      rejectedActionsNote: 'اقدام‌های بررسی پس از ذخیرهٔ بازبینی جدید دوباره فعال می‌شوند.',
      warningsNonBlocking: 'هشدارها مانع تأیید یا انتشار نمی‌شوند.',
      errorsBlocking: 'پیش از تأیید بازبینی باید این خطاها رفع شوند.',
      previewNotesTitle: 'یادداشت‌های پیش‌نمایش',
      previewNotesNonBlocking: 'این موارد فقط از پیش‌نمایش می‌آیند و مانع انتشار نیستند.',
    },
  },
} as const;
